export const XO_SESSION_TOKEN = 'xo-session-token';

export const passwordSubText =
	'8-48 characters, uppercase and lowercase letters, a number';

export const passwordValidationPattern =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,48}$/;
